export type MentionType = "project" | "branch" | "time" | "agent";

export interface MentionItem {
  id: string;
  type: MentionType;
  label: string;
  value: string; // The actual value to be used in filters
  icon?: string;
  color?: string;
  projectName?: string; // For branch items
}

export interface MentionContext {
  showMenu: boolean;
  searchQuery: string;
  cursorPosition: number;
  mentionStartIndex: number;
}

// Time filter options that can be mentioned
export const TIME_OPTIONS = [
  { value: "today", label: "Today" },
  { value: "week", label: "Past week" },
  { value: "month", label: "Past month" },
] as const;

export type TimeFilterValue = (typeof TIME_OPTIONS)[number]["value"];
